import { Document, Font, Page, pdf, StyleSheet, Text, View } from '@react-pdf/renderer';
import moment from 'moment';
import includes from 'ramda/src/includes';
import isNil from 'ramda/src/isNil';
import PdfHeader from '@components/PdfHeader';
import { inPage } from '~/services/util';
import { KEYS, TITLES } from './Constants';

const styles = StyleSheet.create({
    container: {
        flexDirection: 'column',
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        alignItems: 'stretch',
    },
    listHeader: {
        display: 'flex',
        flexDirection: 'row',
        marginLeft: '10px',
        marginRight: '10px',
        marginBottom: '10px',
        paddingBottom: '10px',
        paddingTop: '10px',
        borderBottomWidth: 0.25,
        borderBottomColor: 'black',
        borderBottomStyle: 'solid',
    },
    fontStyle1: {
        fontSize: '10',
        fontWeight: 'normal',
        fontFamily: 'Roboto',
    },
    fontStyle2: {
        fontSize: '12',
        fontWeight: 'light',
        fontFamily: 'Roboto',
    },
});

Font.register({
    family: 'Roboto',
    fonts: [
        {
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
            fontWeight: 'normal',
        },
        {
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
            fontWeight: 'bold',
        },
        {
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
            fontWeight: 'light',
        },
    ],
});

const EngagementPdf = ({ state, props }) => {
    const { activeTab, date, current: page, per, userIds } = state;

    const { engagements } = props;

    const data = engagements[activeTab];

    const total = engagements.totals;

    pdf(
        <Document>
            <Page size="letter" style={styles.container} wrap>
                <PdfHeader style={{ paddingTop: 20 }} header={`Engagement Report - ${activeTab}`} date={`${moment(date.start).format('MMM D')} - ${moment(date.end).format('MMM D')}`} fixed />
                <View wrap style={{ display: 'flex', marginTop: '20px' }}>
                    <View style={styles.listHeader} fixed>
                        <View style={{ flex: 2 }}>
                            <Text style={styles.fontStyle1}>Company</Text>
                        </View>
                        {TITLES[activeTab].map((title, index) => (
                            <View style={{ flex: 1 }}>
                                <View style={{ flex: 2 }}>
                                    <Text style={[styles.fontStyle1, { textAlign: 'right' }]}>{title[0]}</Text>
                                </View>
                                <View style={{ flex: 2 }}>
                                    <Text style={[styles.fontStyle1, { textAlign: 'right' }]}>{title[1]}</Text>
                                </View>
                            </View>
                        ))}
                    </View>
                </View>
                {isNil(data) || data.length === 0 || isNil(total) ? (
                    <View style={{ display: 'flex' }}>
                        <Text style={[styles.fontStyle2, { textAlign: 'center' }]}>No records available</Text>
                    </View>
                ) : (
                    <View>
                        {total.map((total, index) => (
                            <View style={styles.listHeader} fixed key={index}>
                                <View style={{ flex: 2 }}>
                                    <Text style={styles.fontStyle1}>Total</Text>
                                </View>
                                {KEYS[activeTab].length > 0 ? (
                                    KEYS[activeTab].map((key, i) => (
                                        <View style={{ flex: 1 }}>
                                            <View style={{ flex: 2 }}>
                                                <Text style={[styles.fontStyle1, { textAlign: 'right' }]}>{key.includes('completion') ? total[key]?.complete : total[key]?.count || 0}</Text>
                                            </View>
                                            <View style={{ flex: 2 }}>
                                                <Text style={[styles.fontStyle1, { textAlign: 'right' }]}>{total[key]?.percent || 0}%</Text>
                                            </View>
                                        </View>
                                    ))
                                ) : (
                                    <View style={{ flex: 10 }}>
                                        <Text style={[styles.fontStyle1, { textAlign: 'center' }]}>No records available</Text>
                                    </View>
                                )}
                            </View>
                        ))}
                        {data.map((company, index) => {
                            if ((userIds.length > 0 && includes(company.id, userIds)) || (userIds.length === 0 && inPage(index, page, per)))
                                return (
                                    <View style={styles.listHeader} fixed key={index}>
                                        <View style={{ flex: 2 }}>
                                            <Text style={[styles.fontStyle1, { paddingLeft: '10px' }]}>{company.name}</Text>
                                        </View>
                                        {KEYS[activeTab].length > 0 ? (
                                            KEYS[activeTab].map((key, i) => (
                                                <View style={{ flex: 1 }}>
                                                    <View style={{ flex: 2 }}>
                                                        <Text style={[styles.fontStyle1, { textAlign: 'right' }]}>
                                                            {key.includes('completion') ? company.report[key]?.complete : company.report[key]?.count || 0}
                                                        </Text>
                                                    </View>
                                                    <View style={{ flex: 2 }}>
                                                        <Text style={[styles.fontStyle1, { textAlign: 'right' }]}>{company.report[key]?.percent || 0}%</Text>
                                                    </View>
                                                </View>
                                            ))
                                        ) : (
                                            <View style={{ flex: 10 }}>
                                                <Text style={[styles.fontStyle1, { textAlign: 'center' }]}>No records available</Text>
                                            </View>
                                        )}
                                    </View>
                                );
                        })}
                    </View>
                )}
            </Page>
        </Document>
    )
        .toBlob()
        .then((e) => {
            const url = URL.createObjectURL(e);
            window.open(url, '__blank');
        });
};

export default EngagementPdf;
